// --- src/pages/Listings.js ---
import React from "react";
import { Link } from "react-router-dom";
import listings from "../data/listings";

const Listings = () => (
  <section id="listings" className="py-20 bg-[#F5F5F5] px-6 md:px-20">
    <h2
      className="text-3xl 
     font-bold  text-gray-900 custom-heading
    text-center mb-4"
    >
      Featured Listings
    </h2>
    <p className="text-lg leading-relaxed text-gray-700 text-center mb-10 ">
      Check out my latest listings on market
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {listings.slice(0, 6).map((listing) => (
        <Link
          to={`/listing/${listing.id}`}
          key={listing.id}
          className="block bg-gray-100 rounded-lg shadow hover:shadow-xl transition duration-300 overflow-hidden"
        >
          <img
            src={listing.image}
            alt={listing.title}
            className="w-full h-48 object-cover"
          />
          <div className="p-4">
            <h3 className="text-xl font-semibold mb-2">{listing.title}</h3>
            <p className="text-gray-600 text-sm mb-2">{listing.location}</p>
            <p className="text-blue-900 font-bold">${listing.price}</p>
          </div>
        </Link>
      ))}
    </div>

    <div className="text-center mt-10">
      <Link
        to="/all-listings"
        className="inline-block bg-brand hover:bg-yellow-600 text-white px-6 py-3  rounded transition"
      >
        View More
      </Link>
    </div>
  </section>
);

export default Listings;
